import AdminClient from '@/api/AdminClient';
import moment from 'moment';
import debounce from 'debounce';

export default class RegistrationsReport {
  constructor() {
    this.adminClient = null;
    this.schoolId = 0;

    this.loading = true;
    this.loadedOnce = false;
    this.error = null;
    this.parameters = {
      from: moment().subtract(90, 'days').format('YYYY-MM-DD'),
      through: moment().format('YYYY-MM-DD'),
      binBy: 'month',
      customCampusTags: [],
    };
    this.data = {};

    this.fetch = debounce(this.fetch.bind(this), 250);
  }

  async initialize($http, schoolId) {
    this.adminClient = new AdminClient($http);
    this.schoolId = schoolId;
    await this.fetch();
  }

  async setParameters(parameters) {
    this.parameters = { ...this.parameters, ...parameters };
    await this.fetch();
  }

  async fetch() {
    try {
      this.loading = true;
      this.data = await this.adminClient.getCollegeAdminRegistrationsReport(
        this.schoolId,
        this.parameters.from,
        this.parameters.through,
        this.parameters.binBy,
        this.parameters.customCampusTags
      );
    } catch (error) {
      this.error = error;
    } finally {
      this.loading = false;
      this.loadedOnce = true;
    }
  }
}
